<div *ngIf="(!isHidden && group) || displayImages">

    <ng-container [ngSwitch]="imageType">
        <div *ngSwitchCase="imageTypes.VehiclePhoto">
            <p class="image-container-message">Please ensure that photos contain only car images and no customer
                document images</p>
        </div>
        <div *ngSwitchCase="imageTypes.ScannedDocument">
            <p *ngIf="displayImages" class="image-container-message doc">Please upload all mandatory document images
                before
                continuing
            </p>
        </div>
    </ng-container>
    <div class="wrapper">
        <div *ngFor="let image of imagesToSave; let i = index;" class="wrapper-library-item">
            <div>
                <div class="lib-image-input" [ngClass]="{ 'no-image': image.thumbnailUrl == null }">
                    <div [hidden]="image.thumbnailUrl" (click)="openCamera(image, i)" class="document-name">
                        {{ image.documentName }}
                    </div>
                    <img class="obfuscated-playback lib-thumbnail" [hidden]="!image.thumbnailUrl"
                        [src]="image.thumbnailUrl" alt="" [ngClass]="loadingImage(image)"
                        (click)="showPreview(image, preview)"
                        [ngClass]="{'opacity failed': image.status == Status.Failed ||image.status == Status.ImageRecognitionFailed, 'completed': image === Status.Completed}" />
                    <img class="failed-cover" src="../../assets/icons/retry.svg" alt=""
                        *ngIf="image.status === Status.Failed || image.status === Status.ImageRecognitionFailed"
                        (click)="openCamera(image, i)">
                </div>
                <div *ngIf="image.status == Status.Loading">
                    <div class="upload-bar" [style.width.%]="image.progress"></div>
                    <div class="uploading-status loading">{{ image.progress }}%
                        {{image.status}}</div>
                </div>
                <div *ngIf="image.status == Status.Queued">
                    <div class="loading-bar queued"></div>
                    <div class="uploading-status" *ngIf="image.status == Status.Queued ">
                        {{image.status}}</div>
                </div>
                <div *ngIf="apiResult(image.status)">
                    <div class="loading-bar" [ngClass]="loadingBar(image.status)"></div>
                    <div class="uploading-status" [ngClass]="checkStatus(image.status)" *ngIf="image.status">
                        {{image.status}}</div>
                </div>
                <div class="btn-box">
                    <button class="camera-button" *ngIf="!image.thumbnailUrl && !isFailed(image.status)"
                        (click)="openCamera(image, i)"
                        [ngClass]="{ 'mini-button':  showUploadButton && !image.thumbnailUrl,  'active':  image.thumbnailUrl, 'isTaken': image.thumbnailUrl != null && !image.hasMismatch, 'inProgress': inProgress, 'hasMismatch': image.hasMismatch }"
                        [disabled]="image.thumbnailUrl != null && !image.hasMismatch">
                        <span class="camera-btn-icon"
                            [ngClass]="{ 'active': !isManualInput, 'isTaken': image.thumbnailUrl != null && !image.hasMismatch, 'inProgress': inProgress, 'camera-btn-icon-red': image.hasMismatch}"></span>
                    </button>
                    <button class="camera-button" *ngIf="image.thumbnailUrl" (click)="deleteImage(image)"
                        [disabled]="isPostPurchase && !isFromPurchaseMenu"
                        [ngClass]="{ 'active': !isManualInput && image.thumbnailUrl, 'inProgress': inProgress, 'isTaken':isPostPurchase && !isFromPurchaseMenu}">
                        <span class="delete-icon"
                            [ngClass]="{ 'active': !isManualInput, 'isTaken': image.thumbnailUrl != null && !image.hasMismatch, 'inProgress': inProgress}"></span>
                    </button>
                    <button class="camera-button upload-button" *ngIf="!image.thumbnailUrl && showUploadButton"
                        (click)="openFile(image, i)"
                        [ngClass]="{ 'mini-button': showUploadButton,  'active': !isManualInput && image.thumbnailUrl,  'inProgress': inProgress, 'hasMismatch': image.hasMismatch }"
                        [disabled]="image.thumbnailUrl != null && !image.hasMismatch">
                        <span class="camera-btn-icon upload-btn-icon"
                            [ngClass]="{ 'active': !isManualInput, 'inProgress': inProgress, 'upload-btn-icon-red': image.hasMismatch}"></span>
                    </button>
                </div>
            </div>
        </div>
        <button [disabled]="!displayImages" [ngClass]="{ 'action-button-no-margin': checkAddImageButton}"
            class="library-action-button" (click)="onAddImageClick()">
            <span>Add Image</span>
        </button>
    </div>
    <div *ngIf="imageRecognitionFailed">
        <p class="message doc">**Please take a quality photo of the V5**</p>
        <p *ngIf="checkUploadFailed" class="message doc">
            One or more images has failed to upload. You can either retry or take a new image.
        </p>
    </div>
    <div *ngIf="!imageRecognitionFailed">
        <p *ngIf="checkUploadFailed" class="message doc">
            One or more images has failed to upload. You can either retry or take a new image.
        </p>
    </div>

</div>

<input #cameraInput hidden type="file" capture="camera" accept="image/*" id="cameraInput" name="cameraInput"
    (change)="addQueuedImage($event, null)">
<input #fileInput hidden type="file" accept="image/*" id="fileInput" name="fileInput"
    (change)="addQueuedImage(null, null)">

<ng-template #preview let-modal>
    <div class="modal-header">
        <h4 class="modal-title text-center">{{ previewTitle }}</h4>
    </div>
    <div class="modal-body obfuscated-playback">
        <img [src]="previewString" alt="" width="100%" />
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary" (click)="modal.close()" ngbAutofocus>Close</button>
    </div>
</ng-template>